var r = /* @__PURE__ */ ((E) => (E.TREATED = "treated", E.NOT_TREATED = "not_treated", E))(r || {}), C = /* @__PURE__ */ ((E) => (E.CSAT = "CSAT", E.NPS = "NPS", E.FREE_FORM = "FREE_FORM", E.MULTIPLE_CHOICE = "MULTIPLE_CHOICE", E))(C || {});
export {
  C as FeedbackFormFieldTypeEnum,
  r as FeedbackResultStateEnum
};
